var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigmalogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 20,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 60.5C19.5 54.8391 24.0891 50.25 29.75 50.25H40V60.5C40 66.1609 35.4109 70.75 29.75 70.75C24.0891 70.75 19.5 66.1609 19.5 60.5Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 40C40 34.3391 44.5891 29.75 50.2499 29.75C55.9109 29.75 60.5 34.3391 60.5 40C60.5 45.6609 55.9109 50.25 50.2499 50.25C44.5891 50.25 40 45.6609 40 40Z",
    fill: "#1ABCFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 40C19.5 45.6609 24.0891 50.25 29.75 50.25H40V29.75L29.75 29.75C24.0891 29.75 19.5 34.3391 19.5 40Z",
    fill: "#A259FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 9.25V29.75H50.25C55.9109 29.75 60.5 25.1609 60.5 19.5C60.5 13.8391 55.9109 9.25 50.25 9.25H40Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C19.5 25.1609 24.0891 29.75 29.75 29.75L40 29.75V9.25L29.75 9.25C24.0891 9.25 19.5 13.8391 19.5 19.5Z",
    fill: "#F24E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmalogos);
export default __webpack_public_path__ + "static/media/figmalogos.ab906b178c6913b937f972961ab6e49c.svg";
export { ForwardRef as ReactComponent };